import React from "react";

export function ExpertTabPanes() {
  return <div>Expert Tab Panes</div>;
}
